// extracted by mini-css-extract-plugin
export var suiteList = "MosaicSuites-module--suite-list--8d58c";